@import 'apps/webcomponents/src/assets/style-helpers.scss';
@import 'apps/webcomponents/src/assets/common.scss';

.details-panel-wrapper {
  padding: 20px;

  .details-panel {
    padding: 10px;

    .details-panel-header {
      margin-bottom: 25px;
    }

    .details-panel-content-title {
      text-transform: uppercase;
    }

    .section-title {
      color: var(--chart-300-icon-buttons);
    }

    table {
      width: 100%;
    }

    .details-panel-details-wrapper {
      padding-top: 50px;

      hr {
        border: none;
        height: 1px;
        background-color: var(--chart-101-pressed-dividers);
      }

      gz-text {
        line-height: 1.27;
      }
    }

    .details-panel-actions {
      position: absolute;
      bottom: 20px;
      display: flex;

      gz-button {
        --button-max-width: 185px;
      }
    }
  }
}
